import { useGetAssignedDocumentList } from 'features/document-report/use-cases/get-assigned-documents';
import { useUserContext } from 'features/users';
import { Fragment, useEffect } from 'react';

import { CategoryDetails } from './category-details';

export const DocumentCategoryView = ({
  setAddCommentsModal,
  setCommentsInfo,
  setDocumentUploadModal,
  selectedValue,
  searchName,
  finishedValue,
  initilaMarkFinished,
  // selectFilterValue,
  month,
  year,
}: any) => {
  const { user } = useUserContext();
  // const { data: assignedClientDocument } = useAssignDocuments(user?.CompanyId);
  const { data: assignedClientDocument, refetch } = useGetAssignedDocumentList({
    CompanyId: user?.CompanyId,
    // PeriodId: selectedValue || 1,
    ClientId: user?.Id,
    Year: year,
    Month: month,
    Name: searchName,
  } as any);

  useEffect(() => {
    if (selectedValue) {
      refetch();
    }
  }, [selectedValue, searchName]);

  if (!assignedClientDocument) return <div>Loading...</div>;

  return (
    <Fragment>
      {/* <CategoryDocumentView
        Category_document={assignedClientDocument.rc}
        CompanyId={CompanyId}
      /> */}
      <CategoryDetails
        Category_document={assignedClientDocument.rc}
        setCommentsInfo={setCommentsInfo}
        setAddCommentsModal={setAddCommentsModal}
        setDocumentUploadModal={setDocumentUploadModal}
        // selectedValue={selectedValue}
        searchName={searchName}
        year={year}
        month={month}
        finishedValue={finishedValue}
        initilaMarkFinished={initilaMarkFinished}
        // selectFilterValue={selectFilterValue}
      />
    </Fragment>
  );
};
